import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { SeoService } from '../../shared/seo/seo.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tata-mitra-blog-details',
  templateUrl: './tata-mitra-blog-details.component.html',
  styleUrls: ['./tata-mitra-blog-details.component.scss']
})
export class TataMitraBlogDetailsComponent implements OnInit {
  sub: Subscription = new Subscription
  blogId: any;
  detailList: any;
  recentBlogs: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  breadcrumbList1: {
    label: any; url: string;
    pageName: string;
  };
  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute,
    private localStorage:secureStorage, private Router:Router,
    private cleverService: ClevertapService, private seoservice: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Tata Mitra Blog Details");
      } catch { }
    }    this.activatedRoute.paramMap.subscribe(params => {
      this.blogId = params.get('id')
    })
    this.getBlogId();
    this.getTotalBlogs();
  }

  getBlogId() {
    let data = {
      "id": this.blogId
    }
    this.sub.add(this.apiService.getBlogList(data).subscribe({
      next: (res: any) => {
        this.detailList = res.data[0];
        this.breadcrumb();
      },
      error: () => {

      },
      complete: () => {
        this.seo(this.detailList.meta_title,this.detailList.meta_description);
      }
    }))
  }
  getTotalBlogs(){
    let data = {
      "offset": 0,
      "limit": 6,
      "blog_status":"APPROVED"
    }
    this.sub.add(this.apiService.getBlogList(data).subscribe({
      next: (res: any) => {
        this.recentBlogs = res.data
      }
    }))
  }

  breadcrumb(){
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('localBreadCrumb');
    }
    this.breadcrumbList1 = {
      label: 'Blogs and Stories',
      url:`/blogs-and-stories/`,
      pageName: 'tata-mitra',

    };

    this.breadcrumbdata.push(this.breadcrumbList1);
    let label;
    if(this.detailList?.title.split(" ")?.length > 2){
    label = (this.detailList?.title).split(' ').slice(0,3)
    label = label[0] + ' '+ label[1] + ' '+ label[2].substring(0,3) + '...'
  }
    else{
      label = this.detailList?.title;
    }
    this.breadcrumbList1 = {
      label:label,
      url: ``,
      pageName: 'tata-mitra detail',

    };
    this.breadcrumbdata.push(this.breadcrumbList1);
    if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    }
    this.showBreadCrumb = true;
  }

  gotoPath(title,id){
    var title = title.replace(/\s/g, "-").replace(/\//g, "-").replace(/\+/g, "-").replace(/\./g, "-").replace(/\,/g, "-").replace(/\:/g, "-").replace(/\?/g, "-");
    var path = 'blogs-and-stories/'+ title+'/'+id;
    this.Router.navigate([path]);
    this.blogId=id
    this.getBlogId()
  }

  seo(title,description) {
    this.seoservice.updateTitle(title);
    this.seoservice.updateMetaTag("description", null, description);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      title
    );
    this.seoservice.updateMetaTag(null, "og:description", description);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.Router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }
}
